import React from 'react';
import { Modal } from './Modal';

interface ParameterDiagramModalProps {
  isOpen: boolean;
  onClose: () => void;
  imageUrl: string | null;
  title?: string;
  className?: string;
}

export const ParameterDiagramModal: React.FC<ParameterDiagramModalProps> = ({
  isOpen,
  onClose,
  imageUrl,
  title = '',
  className = 'parameter-diagram-modal',
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      className={className}
    >
      <div className="sai-preview-container" style={{ minHeight: 200, border: 0 }}>
        {imageUrl ? (
          <img
            src={imageUrl}
            alt="SAI Parameter Diagram"
            className="sai-preview-image"
            style={{ maxWidth: '100%', height: 'auto' }}
          />
        ) : (
          <div className="parameter-diagram-no-image">
            <span className="parameter-diagram-no-image-text">No image</span>
          </div>
        )}
      </div>
    </Modal>
  );
};
